import { useCompanyApi } from '@lendica/hooks';
import React from 'react';

export const useDrawDownApi = () => {
    const api = useCompanyApi();
    return React.useMemo(
        () => ({
            getDealsList: (page = 1, pageSize = 20) =>
                api.get('/deals/list', {
                    params: { page, page_size: pageSize, product_name: 'drawdown' },
                }),
            getDealById: async id => {
                const deal = await api.get('/deals/detail', { params: { deal_id: id } });
                return deal;
            },
            getCompanyDetails: () => api.get('/companies/detail'),
            getDrawDownApproval: async (page = 1, pageSize = 20) => {
                const approvals = await api.get('/approvals/list', {
                    params: { product_name: 'drawdown', active: true, page, page_size: pageSize },
                });

                // Sort by contract start date descending, normally it should return only one active approval for each product
                let drawdownApproval = approvals.results
                    .filter(
                        a => a.product_name === 'drawdown' && a.active && a.qualified_amount > 0
                    )
                    .sort((a, b) => b.contract_start_date - a.contract_start_date);

                if (!drawdownApproval.length) return null;
                const approvalDetails = await api.get(
                    `/approvals/detail?approval_id=${drawdownApproval[0].id}`
                );

                const rateCurves = await api.get('/ratecurve_backbones/detail');

                const rates = rateCurves
                    .filter(r => r.approval === approvalDetails.id)
                    .sort((a, b) => b.day - a.day);

                return [approvalDetails, rates];
            },
            activateDrawdown: () => api.get('/drawdown/activate'),
            withdraw: amount =>
                api.post('/drawdown/deal/init', {
                    withdrawal_amount: amount,
                }),
        }),
        [api]
    );
};

// export const getDeals = async () => {
//     const response = await axios.get('/company/deals');
//     return response.data.filter(d => d.product_name === 'drawdown');
// };

// export const getCompanyDetails = async () => {
//     const response = await axios.get('/company/details');
//     return response.data;
// };

// export const getDrawDownApproval = async () => {
//     const response = await axios.get('/company/approvals', { product_name: 'drawdown' });
//     return response.data;
// };

// export const getApprovalDetails = async approvalId => {
//     const response = await axios.get(`/company/approvals?id=${approvalId}`);
//     return response.data;
// };

// export const getDealById = async id => {
//     const response = await axios.get('/company/deals', { params: { id: id } });
//     return response.data;
// };

// export const withdraw = async amount => {
//     const response = await axios.post('/drawdown/deal/init', {
//         withdrawal_amount: amount,
//     });
//     return response.data;
// };

// export const getRateCurves = async () => {
//     const response = await axios.get('/company/ratecurve_backbones');
//     return response.data;
// };

// export const activateDrawdown = async () => {
//     return (await axios.get('/drawdown/activate')).data;
// };
